import { render, staticRenderFns } from "./group-floating-bar-options.vue?vue&type=template&id=012f175e"
import script from "./group-floating-bar-options.vue?vue&type=script&lang=ts"
export * from "./group-floating-bar-options.vue?vue&type=script&lang=ts"
import style0 from "./group-floating-bar-options.vue?vue&type=style&index=0&id=012f175e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports